import React, { useState, useEffect } from "react";
import i18n from "i18n-react";
import { BackImage, DataHandler, StorageHandler } from "C4";
import { storageKeys, name, appURL } from "settings";

import appleStoreLogo from "assets/images/app_store.png";
import googlePlayLogo from "assets/images/google_play.png";

const MobileWarning = () => {
  const [appId, setAppId] = useState(0);
  const [appInfo, setAppInfo] = useState({});

  useEffect(() => {
    StorageHandler.load(storageKeys.appInfo)
      .then((info) => {
        if (info) {
          setAppInfo(info);
        }
      })
      .catch((err) => console.warn("MobileWarning: could not load app info", err));
    DataHandler.matchAppId().then((id) => {
      setAppId(id);
    });
  }, []);

  const appName = name || appInfo.appName;
  const { appleStore, googlePlay } = appInfo;
  const desktopUrl = appURL.replace(/^https?:\/\//, "");

  return (
    <div>
      <div className="container__mobileButtons">
        <BackImage darken />
        <div className="container__mobileButtons__holder">
          <h2>{i18n.translate("onMobile.header")}</h2>
          <section>{i18n.translate("onMobile.body", { appName })}</section>
          <h5>{i18n.translate("onMobile.benefits.header")}</h5>
          <ul>
            <li>{i18n.translate("onMobile.benefits.1")}</li>
            <li>{i18n.translate("onMobile.benefits.2")}</li>
            <li>{i18n.translate("onMobile.benefits.3")}</li>
          </ul>
          <section>
            {i18n.translate("onMobile.desktop", {
              link: <a href={appURL}>{desktopUrl}</a>,
            })}
          </section>
          <div className="buttons">
            <a href={appleStore}>
              <img src={appleStoreLogo} alt="App store" />
            </a>
            <a href={googlePlay}>
              <img src={googlePlayLogo} alt="Google Play" />
            </a>
          </div>
          <hr />
          <span>
            {"App: "}
            {appId}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileWarning;
